import { ChunkDataProvider } from '@common/api';
import { CollisionSystem } from '@common/systems/CollisionSystem';

import { ClientServiceContainer } from '../services/ClientServiceContainer';

/**
 * Client-side implementation of CollisionSystem.
 * Provides access to client chunk data.
 */
export class ClientCollisionSystem extends CollisionSystem {
  private clientServices: ClientServiceContainer;

  constructor(clientServices: ClientServiceContainer) {
    super(clientServices.common);
    this.clientServices = clientServices;
  }

  protected getChunkDataProvider(): ChunkDataProvider | undefined {
    return this.clientServices.chunkData;
  }
}
